import React, {Component} from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {LanguageService} from "../language/LanguageService";
import {CategoryRepository, ICategory} from "../repositories/category/CategoryRepository";
import {
  emptyICountSsqDataByDocType,
  emptyTechnicalCountOfEachDocTypeRequest,
  emptyTechnicalGetSsqDataByPageRequest,
  ICountOfEachDocTypeRequest,
  ICountsOfEachDocType,
  IGetSsqDataByPageRequest,
  ISsqDataDocument,
  SsqDataRepository
} from "../repositories/SsqDataRepository";
import {
  ErrorpageWrap,
  TabItem,
  TechnicalDocumentListArea,
  TitleBarContainer,
  TitleBarContents,
  TitleBarItem,
  ViewmoreArea
} from "../style/CommonStyledComponents";
import {CategoryType} from "../definitions/CategoryType";
import {SsqImages} from "../images/SsqImages";
import TechnicalDocumentListItem from "../productpage/TechnicalDocumentListItem";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import {SolutionTabType} from "../definitions/SolutionTabType";
import styled from "styled-components";
import {HomepageBtn} from "../productpage/CategoryCards";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Mousewheel, Navigation, Scrollbar} from "swiper";
import 'swiper/swiper.min.css';
import {SwiperArrow} from "../productpage/ProductPage";
import TagManager from "react-gtm-module";
import {langutil} from "language/langutil";
import axios from "axios";
import {getLangSuffix, HelmetTitleAndH1} from "../ctls/common/HelmetTitleAndH1";
import {tcommona} from "language/i18nkey";
import svcs from "services";
import {ssqutil} from "util/ssqutil";
import {fontFamilyBoldImportant} from "style/fonts";
import {connect} from "react-redux";
import {IfLoginInfo} from "models/IfLoginInfo";

interface ISolutionPageMatchParams {
  categoryId: string;
  country?: string;
  lang?: string;
}


interface Props extends RouteComponentProps<ISolutionPageMatchParams> {
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  loginInfo: IfLoginInfo;
}

interface State {
  selectedCategoryType: string;
  allSolutionCategories: ICategory[];
  selectedCategoryId: number;
  ssqDataDocuments: ISsqDataDocument[];
  ssqDataDocumentsCounts: ICountsOfEachDocType;
  pageNum: number;
  selectedTabName: string;
  selectedTabIndex: number;
  hoveredCategoryId: number;
  hoveredExpendedCategoryId: number;
  isMobile: boolean;
  categoryIdInMobile: number;
  homepagebtnshow: boolean;
}

class SolutionPage extends Component<Props, State> {
  private readonly NO_DATA = "NO_DATA";
  private readonly PAGE_NUM_UNIT = 20;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectedCategoryType: CategoryType.INDUSTRY,
      allSolutionCategories: [],
      selectedCategoryId: 0,
      ssqDataDocuments: [],
      ssqDataDocumentsCounts: emptyICountSsqDataByDocType,
      pageNum: 0,
      selectedTabName: SolutionTabType.TECHNICAL_GUIDE,
      selectedTabIndex: 0,
      hoveredCategoryId: 0,
      hoveredExpendedCategoryId: 0,
      isMobile: false,
      categoryIdInMobile: 0,
      homepagebtnshow: false
    };
  }

  getTranslation(key: string): string {
    this.props.languageService.setNamespace("I18N_NAMESPACE_SOLUTION_PAGE");
    return this.props.languageService.getTranslationByKey(key) || "";
  }

  async componentDidMount() {
    if (!langutil.isCountryLangUrl()) { // url에 국가/언어가 없으면.
      const categoryId = this.props.match.params.categoryId;
      const info: ICategory = (await axios.get('/api/guest/ssqData/category/get/' + categoryId)).data;
      document.location.href = langutil.getCountryLangUrl(info.lang);
      return; // 다음으로 진행하지 않도록.
    }

    if (window.innerWidth < 1199)
      this.setState({isMobile: true});
    else
      this.setState({isMobile: false});

    let selectedCategoryType = CategoryType.INDUSTRY;
    await this.getAllSolutionCategories(selectedCategoryType);

    const {categoryId} = this.props.match.params;

    await this.getSsqDataDocumentsCounts(Number(categoryId));
    await this.getSsaDataDocuments(Number(categoryId));

    if (Number(categoryId) !== 0 && this.state.allSolutionCategories.filter(category => category.id === Number(categoryId)).length === 0) {
      selectedCategoryType = CategoryType.APPLICATION_LOAD;
      await this.getAllSolutionCategories(selectedCategoryType);
    }

    this.setState({
        selectedCategoryType,
        selectedCategoryId: Number(this.props.match.params.categoryId),
        pageNum: 0
      }
    );
    window.scrollTo(0, 0);
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const selectedCategoryId = this.props.match.params.categoryId;
    let selectedCategoryType = this.state.selectedCategoryType;

    if (prevProps.match.params.categoryId != selectedCategoryId) {
      await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));
      await this.getSsaDataDocuments(Number(selectedCategoryId));

      if (Number(selectedCategoryId) !== 0 && this.state.allSolutionCategories.filter(category => category.id === Number(selectedCategoryId)).length === 0) {
        if (selectedCategoryType === CategoryType.APPLICATION_LOAD) {
          selectedCategoryType = CategoryType.INDUSTRY;
        } else {
          selectedCategoryType = CategoryType.APPLICATION_LOAD;
        }
        await this.getAllSolutionCategories(selectedCategoryType);
      }

      this.setState({
        pageNum: 0,
        selectedTabIndex: 0,
        selectedCategoryId: Number(selectedCategoryId),
        selectedCategoryType
      });

    } else if (prevState.selectedTabName != this.state.selectedTabName) {
      await this.getSsaDataDocuments(Number(selectedCategoryId));
      this.setState({pageNum: 0});

    } else if (prevState.pageNum != this.state.pageNum) {
      await this.getSsaDataDocuments(Number(selectedCategoryId), true);

    } else {
      // console.log("업데이트 할 필요 없음")
    }
  }

  getDefaultSelectedTab(ssqDataDocumentsCounts: ICountsOfEachDocType) {
    if (ssqDataDocumentsCounts.technicalGuideCount > 0)
      return SolutionTabType.TECHNICAL_GUIDE;
    else if (ssqDataDocumentsCounts.applicationNoteCount > 0)
      return SolutionTabType.APPLICATION_NOTE;
    else if (ssqDataDocumentsCounts.sampleCount > 0)
      return SolutionTabType.SAMPLE;
    else
      return SolutionTabType.APPLICATION_NOTE;
  }

  isExistDocumentByTab(tabName: String): boolean {
    if (tabName === SolutionTabType.APPLICATION_NOTE) {
      return this.state.ssqDataDocumentsCounts.applicationNoteCount > 0;
    } else if (tabName === SolutionTabType.TECHNICAL_GUIDE) {
      return this.state.ssqDataDocumentsCounts.technicalGuideCount > 0;
    } else if (tabName === SolutionTabType.SAMPLE) {
      return this.state.ssqDataDocumentsCounts.sampleCount > 0;
    } else {
      return false;
    }
  }

  async getSsaDataDocuments(categoryId: number, pageChanged: boolean = false) {

    let getSsqDataByPageRequest: IGetSsqDataByPageRequest = {
      ...emptyTechnicalGetSsqDataByPageRequest,
      pageNum: this.state.pageNum,
      categoryId: categoryId,
      docTypes: [this.state.selectedTabName],
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      categoryTypeName: this.state.selectedCategoryType,
      userId: this.props.loginInfo.userId
    };

    let ssqDataDocuments = await this.props.ssqDataRepository.getSsqDataByPage(getSsqDataByPageRequest);

    if (this.state.pageNum > 0 && pageChanged) {
      this.setState({ssqDataDocuments: [...this.state.ssqDataDocuments, ...ssqDataDocuments]});
    } else {
      this.setState({ssqDataDocuments});
    }
  }

  async getSsqDataDocumentsCounts(categoryId: number) {
    let countOfEachDocTypeRequest: ICountOfEachDocTypeRequest = {
      ...emptyTechnicalCountOfEachDocTypeRequest,
      categoryId: categoryId,
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      categoryTypeName: this.state.selectedCategoryType,
      userId: this.props.loginInfo.userId
    };

    let ssqDataDocumentsCounts =
      await this.props.ssqDataRepository.getCountsOfEachDocType(countOfEachDocTypeRequest);

    let selectedTab = this.getDefaultSelectedTab(ssqDataDocumentsCounts);

    this.setState({ssqDataDocumentsCounts, selectedTabName: selectedTab});
  }

  getSolutionSsqDataDocumentsCount() {
    return this.state.ssqDataDocumentsCounts.applicationNoteCount +
      this.state.ssqDataDocumentsCounts.sampleCount +
      this.state.ssqDataDocumentsCounts.technicalGuideCount;
  }

  getSsqDataDocumentsCountByTabType() {
    if (SolutionTabType.APPLICATION_NOTE == this.state.selectedTabName) {
      return this.state.ssqDataDocumentsCounts.applicationNoteCount;
    } else if (SolutionTabType.TECHNICAL_GUIDE == this.state.selectedTabName) {
      return this.state.ssqDataDocumentsCounts.technicalGuideCount;
    } else if (SolutionTabType.SAMPLE == this.state.selectedTabName) {
      return this.state.ssqDataDocumentsCounts.sampleCount;
    }
    return 0;
  }

  clickSolutionTabInTagManager(tabType: string) {
    TagManager.dataLayer({
      dataLayer: {
        "event": "click_solution_tab",
        "click_solution_tab": tabType
      }
    });
  }

  renderSolutionCategoryTypeSelectArea() {
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());
    return <div className={"Solution_cate"}>
      <div
        className={this.state.selectedCategoryType === CategoryType.INDUSTRY ? "selected" : ""}>
        <button onClick={async () => {
          await this.getAllSolutionCategories(CategoryType.INDUSTRY);

          this.setState({
            selectedCategoryType: CategoryType.INDUSTRY,
            selectedCategoryId: 0,
            pageNum: 0,
            selectedTabIndex: 0
          });

          await this.getSsqDataDocumentsCounts(Number(0));
          await this.getSsaDataDocuments(Number(0));
          this.props.history.push(`/${country}/${lang}/solution/category/` + 0);
        }}>{this.getTranslation("I18N_CATEGORY_INDUSTRY")}
        </button>
      </div>
      <div
        className={this.state.selectedCategoryType === CategoryType.APPLICATION_LOAD ? "selected" : ""}>
        <button onClick={async () => {
          await this.getAllSolutionCategories(CategoryType.APPLICATION_LOAD);

          this.setState({
            selectedCategoryType: CategoryType.APPLICATION_LOAD,
            selectedCategoryId: 0,
            pageNum: 0,
            selectedTabIndex: 0
          });

          await this.getSsqDataDocumentsCounts(Number(0));
          await this.getSsaDataDocuments(Number(0));
          this.props.history.push(`/${country}/${lang}/solution/category/` + 0);
        }}>{this.getTranslation("I18N_CATEGORY_APPLICATION_LOAD")}
        </button>
      </div>
    </div>;
  }

  renderCategoryCardBody(category: ICategory) {
    return <CategoryCardBody
      onMouseEnter={() => this.setState({hoveredCategoryId: category.id})}
      onMouseLeave={() => this.setState({hoveredCategoryId: 0})}
    >
      {this.state.isMobile ? category.homepageUrl &&
        <HomepageBtn>
          <div
            className={"m_homepage_btn " + (this.state.categoryIdInMobile === category.id ? "homepage_btn_show" : "")}
            onClick={(e) => {
              e.stopPropagation();
              this.setState({categoryIdInMobile: category.id});
              if (this.state.categoryIdInMobile === category.id)
                category.homepageUrl.includes("https://") ? window.open(category.homepageUrl) : window.open("https://" + category.homepageUrl);
            }}
          >
            <div className={"homepage_btn_content"}>
              <span>{this.getTranslation('I18N_DOC_HOMEPAGE_BUTTON')}</span>
              <img src={SsqImages.common.icon.pagelinkGray()}/>
            </div>
          </div>
        </HomepageBtn>
        :
        category.homepageUrl &&
        <HomepageBtn>
          <div
            className={"homepage_btn " + (this.state.hoveredExpendedCategoryId === category.id ? "homepage_btn_show" : "")}
            onMouseEnter={() => this.setState({hoveredExpendedCategoryId: category.id})}
            onMouseLeave={() => this.setState({hoveredExpendedCategoryId: 0})}
            onClick={() => category.homepageUrl.includes("https://") ? window.open(category.homepageUrl) : window.open("https://" + category.homepageUrl)}
          >
            <div className={"homepage_btn_content"}>
              <span>{this.getTranslation('I18N_DOC_HOMEPAGE_BUTTON')}</span>
              <img src={SsqImages.common.icon.pagelinkGray()}/>
            </div>
          </div>
        </HomepageBtn>
      }

      {category.id === this.state.selectedCategoryId && this.renderSelectedCardCover()}
      <img
        className={"category-img"}
        alt={`category-${category.id}.png`}
        src={ssqutil.getCdnUrl(category.imageBlobKey)}
        onError={(e: any) => {
          e.target.src = SsqImages.common.icon.noImage();
          e.target.className = "no-image";
          e.target.alt = "no_image.svg";
        }}
      />
      <div className={"category-name"}>{category.name}</div>
    </CategoryCardBody>;
  }

  renderSelectedCardCover() {
    return <CategorySelectedCover>
      <div className="clicked-card-check"/>
    </CategorySelectedCover>;
  }

  render() {
    SwiperCore.use([Navigation, Mousewheel, Scrollbar]);
    const {country, lang} = langutil.splitLangCode(this.props.languageService.lang());

    const categoryinfo = () => {
      if (!this.state.selectedCategoryId) return [];
      const category = svcs.storeCategory.getCategoryById(this.state.selectedCategoryId);
      return [category.name, ' - '];
    };
    return <>
      <SolutionPageContainer aria-label={"solution-page"}>
        <HelmetTitleAndH1 title={tcommona('I18N_COMMON_TIT_INDUST', categoryinfo(), [getLangSuffix()])}/>
        <TitleBarContainer>
          <TitleBarContents className={"container"}>
            <TitleBarItem><a href={`/${country}/${lang}/main`}>{this.getTranslation("I18N_TITLE_MAIN")}</a></TitleBarItem>
            <TitleBarItem className="selected">{this.getTranslation("I18N_TITLE_SOLUTION")}</TitleBarItem>
          </TitleBarContents>
        </TitleBarContainer>
        <SolutionContentsContainer>
          <div className={"wrapper container"}>
            <SolutionCategoryTop>
              <SolutionCategoryTypeSelectArea>
                <div>
                  {this.renderSolutionCategoryTypeSelectArea()}
                </div>
              </SolutionCategoryTypeSelectArea>
              <SelectedCategoryContents>
                <SolutionCategoryCardListArea>
                  {this.state.selectedCategoryType === CategoryType.INDUSTRY &&
                    <Swiper
                      slidesPerView={'auto'}
                      slidesPerGroup={3}
                      spaceBetween={10}
                      //slidesOffsetBefore={10}
                      navigation={{
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next'
                      }}
                      observer={true}
                      mousewheel={true}
                      scrollbar={{
                        el: '.swiper-scrollbar',
                        draggable: true
                      }}
                    >
                      {this.state.allSolutionCategories.map((category, index) => {
                        return <SwiperSlide key={category.id}><SelectedCategory
                          title={category.description}
                          onClick={() => {
                            this.props.history.push(`/${country}/${lang}/solution/category/` + category.id);
                            this.setState({
                              selectedCategoryId: category.id
                            });

                          }}
                        >
                          {this.renderCategoryCardBody(category)}
                        </SelectedCategory>
                        </SwiperSlide>;
                      })}
                      <div className="swiper-scrollbar">
                        <img
                          className={"category-scroll"}
                          src={SsqImages.product.mousescroll()}/>
                      </div>
                      <SwiperArrow className={"swiper-arrow"}>
                        <p className="swiper-button-prev"></p>
                        <p className="swiper-button-next"></p>
                      </SwiperArrow>
                    </Swiper>
                  }
                  {this.state.selectedCategoryType === CategoryType.APPLICATION_LOAD &&
                    <Swiper
                      slidesPerView={'auto'}
                      slidesPerGroup={3}
                      spaceBetween={10}
                      //slidesOffsetBefore={10}
                      navigation={{
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next'
                      }}
                      observer={true}
                      mousewheel={true}
                      scrollbar={{
                        el: '.swiper-scrollbar',
                        draggable: true
                      }}
                    >
                      {this.state.allSolutionCategories.map((category, index) => {
                        return <SwiperSlide key={category.id}><SelectedCategory
                          title={category.description}
                          onClick={() => {
                            this.props.history.push(`/${country}/${lang}/solution/category/` + category.id);
                            this.setState({
                              selectedCategoryId: category.id
                            });

                          }}
                        >
                          {this.renderCategoryCardBody(category)}
                        </SelectedCategory>
                        </SwiperSlide>;
                      })}
                      <div className="swiper-scrollbar">
                        <img
                          className={"category-scroll"}
                          src={SsqImages.product.mousescroll()}/>
                      </div>
                      <SwiperArrow className={"swiper-arrow"}>
                        <p className="swiper-button-prev"></p>
                        <p className="swiper-button-next"></p>
                      </SwiperArrow>
                    </Swiper>
                  }
                </SolutionCategoryCardListArea>
              </SelectedCategoryContents>
            </SolutionCategoryTop>
            <TechnicalDocumentListArea className={"container"}>
              <div className={"result-area"}>
                {this.checkSsqDataDocumentAllCountsByCategoryIdInSolutionPage() ?
                  this.renderTechnicalDocumentListItem() : this.renderNoDocumentSolutionPage()}
              </div>
            </TechnicalDocumentListArea>
          </div>
        </SolutionContentsContainer>
      </SolutionPageContainer>
    </>;
  }

  renderTechnicalDocumentListItem() {
    return <TabItem>
      <Tabs selectedIndex={this.state.selectedTabIndex}
        onSelect={(e) => this.setState({selectedTabIndex: e,})}>
        <TabList id={"solution_tab"}>
          {this.isExistDocumentByTab(SolutionTabType.TECHNICAL_GUIDE) &&
            <Tab onClick={() => {
              this.clickSolutionTabInTagManager(SolutionTabType.TECHNICAL_GUIDE);
              this.setState({selectedTabName: SolutionTabType.TECHNICAL_GUIDE});
            }}>
              {this.getTranslation("I18N_TAB_TECHNICAL_GUIDE")}
              <span>{this.state.ssqDataDocumentsCounts.technicalGuideCount}</span>
            </Tab>}
          {this.isExistDocumentByTab(SolutionTabType.APPLICATION_NOTE) &&
            <Tab onClick={() => {
              this.clickSolutionTabInTagManager(SolutionTabType.APPLICATION_NOTE);
              this.setState({selectedTabName: SolutionTabType.APPLICATION_NOTE});
            }}>
              {this.getTranslation("I18N_TAB_APPLICATION_NOTE")}
              <span>{this.state.ssqDataDocumentsCounts.applicationNoteCount}</span>
            </Tab>}
          {this.isExistDocumentByTab(SolutionTabType.SAMPLE) &&
            <Tab onClick={() => {
              this.clickSolutionTabInTagManager(SolutionTabType.SAMPLE);
              this.setState({selectedTabName: SolutionTabType.SAMPLE});
            }}>
              {this.getTranslation("I18N_TAB_SAMPLE")}
              <span>{this.state.ssqDataDocumentsCounts.sampleCount}</span>
            </Tab>}
        </TabList>


        {this.isExistDocumentByTab(SolutionTabType.TECHNICAL_GUIDE) && <TabPanel>
          {this.renderDocumentsArea()}
        </TabPanel>}
        {this.isExistDocumentByTab(SolutionTabType.APPLICATION_NOTE) && <TabPanel>
          {this.renderDocumentsArea()}
        </TabPanel>}
        {this.isExistDocumentByTab(SolutionTabType.SAMPLE) && <TabPanel>
          {this.renderDocumentsArea()}
        </TabPanel>}
      </Tabs>
    </TabItem>;
  }

  renderNoDocumentSolutionPage() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"error_empty.svg"} src={SsqImages.common.emptyError()}/>
        <p className={"error-tit"}>{this.getTranslation("I18N_NO_DOCUMENT_SOLUTION")}</p>
        <p className={"error-txt"}>{this.getTranslation("I18N_NO_DOCUMENT_NOTICE_SOLUTION")}</p>
      </div>
    </ErrorpageWrap>;
  }

  checkSsqDataDocumentAllCountsByCategoryIdInSolutionPage() {
    if (this.props.match.params.categoryId === "0") {
      return true;
    }

    if (this.state.ssqDataDocumentsCounts.applicationNoteCount !== emptyICountSsqDataByDocType.applicationNoteCount)
      return true;
    else if (this.state.ssqDataDocumentsCounts.technicalGuideCount !== emptyICountSsqDataByDocType.technicalGuideCount)
      return true;
    else if (this.state.ssqDataDocumentsCounts.sampleCount !== emptyICountSsqDataByDocType.sampleCount)
      return true;

    return false;
  }

  isRenderViewMore() {
    return this.getSsqDataDocumentsCountByTabType() > this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  renderDocumentsArea() {
    return <div>
      {this.state.ssqDataDocuments.map((document, index) => {
        return <TechnicalDocumentListItem
          key={index}
          ssqDocument={document}
          getTranslation={this.getTranslation.bind(this)}
          languageService={this.props.languageService}
        />;
      })}
      {this.isRenderViewMore() && <ViewmoreArea className="viewmore-area-100"
        onClick={() => {
          this.setState({pageNum: this.state.pageNum + 1});
        }}>
        <div className="view-more-list-box">
          <div className={"ViewmoreBtn"}>
            <button className={"view-more-button"}>
              {this.getTranslation("I18N_DOC_VIEW_MORE")}
            </button>
          </div>
          <div className={"ViewmoreNum"}>
            <span className={"page-count"}>{this.PAGE_NUM_UNIT * (this.state.pageNum + 1)}</span>
            <span>{this.getSsqDataDocumentsCountByTabType()} </span>
          </div>
        </div>
      </ViewmoreArea>}
    </div>;
  }

  private async getAllSolutionCategories(selectedCategoryType: string) {
    let language = this.props.languageService.getLanguage();

    let allSolutionCategories = await this.props.categoryRepository.getExposedCategoriesByType(language, selectedCategoryType);

    this.setState({
        allSolutionCategories
      }
    );
  }
}

export default withRouter(connect((state: any) => ({
    loginInfo: state.main.loginInfo,
  })
)(SolutionPage));

const SolutionPageContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #EEF1F6;

  .wrapper {
    position: relative;
  }

  .ErrorpageWrap {
    background: none;

    .Errorpage {
      min-height: 50rem;
    }
  }
`;

const SolutionContentsContainer = styled.div`
  width: 100%;
`;
const SolutionCategoryTop = styled.div`
  width: 100%;
  background: #EAEEF5;
  box-shadow: 0px 20px 20px rgb(0 0 0 / 10%);
  overflow: hidden;
`;
const SolutionCategoryTypeSelectArea = styled.div`
  padding: 1.9rem 3.2rem;

  .Solution_cate {
    width: 220px;

    > div {
      display: inline-block;
    }

    .selected {
      background: #407EDB;

      > button {
        ${fontFamilyBoldImportant};
      }
    }
  }

  .Solution_cate > div {
    width: 50%;
    border-radius: 100px 0 0 100px;
    background: rgba(64, 126, 219, 0.5);
    text-align: center;

    button {
      width: 100%;
      color: rgb(255, 255, 255);
      line-height: 3.2rem;
      font-size: 1.2rem;
    }
  }

  .Solution_cate > div:last-child {
    border-radius: 0 100px 100px 0;
  }

  @media screen and (max-width: 764px) {
    padding: 1.4rem 1.7rem;

    .Solution_cate .selected {
      > button {
        line-height: 3.15rem;
        font-size: 1.2rem;
        ${fontFamilyBoldImportant};
      }
    }

    button {
      line-height: 3.25rem !important;
    }
  }
`;

const SelectedCategoryContents = styled.div`

  @media screen and (max-width: 1199px) {
    box-shadow: none;
  }
`;

const SolutionCategoryCardListArea = styled.div`
  margin-left: 2.2rem;
  position: relative;
  z-index: 1;

  .swiper-slide {
    width: auto;
  }

  .swiper-container {
    padding-bottom: 4rem;
    position: static;
  }

  .category-scroll {
    position: absolute;
    right: 1rem;
    top: -200px;
    width: 28px;
    height: 28px;
  }

  .swiper-wrapper {
    z-index: 51;
  }

  .swiper-scrollbar {
    bottom: 1rem;
    background: transparent;
    position: absolute;
    left: 1%;
    //z-index: 50;
    width: 98%;
    height: 6px;
    border-radius: 10px;
    display: block;

    .swiper-scrollbar-drag {
      background-color: #7783A1;
      height: 100%;
      width: 100%;
      position: relative;
      border-radius: 10px;
      left: 0;
      top: 0;
    }
  }

  .swiper-arrow {
    p {
      height: 17rem;
      //top: 2rem;
      z-index: 52;
    }

    .swiper-button-prev {
      background: linear-gradient(to left, rgb(234 238 245 / 0%), rgb(234 238 245 / 99%) 15px) !important;
      left: -1.6rem
    }

    .swiper-button-next {
      background: linear-gradient(to right, rgb(234 238 245 / 0%), rgb(234 238 245 / 99%) 15px);
    }
  }

  @media screen and (max-width: 1199px) {
    .category-scroll {
      display: none;
    }
  }
  @media screen and (max-width: 764px) {
    margin-left: 6px;
  }
`;

const CategoryCardBody = styled.div`
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  position: relative;
  //overflow: hidden;

  :hover {
    background: rgba(64, 126, 219, 0.1);

    .homepage_btn {
      top: 13rem;
      opacity: 1;
      transition: all .3s ease;
    }
  }

  :active {
    background: rgba(64, 126, 219, 0.3);
  }

  > a {
    border-radius: 6px;
  }

  .category-img {
    width: 100%;
    height: 10rem;
    border-radius: 6px 6px 0 0;
  }

  .no-image {
    width: 10rem;
    height: 10rem;
  }

  .category-name {
    font-size: 1.2rem;
    line-height: 3.2rem;
    display: block;
    width: 100%;
    margin-top: -.4rem;
    text-align: center;
  }

  @media screen and (max-width: 1199px) {
    .category-name {
      font-size: 11px;
    }
  }
  @media screen and (max-width: 764px) {
    :hover {
      background: #ffffff;
    }

    :active {
      background: #ffffff;
    }
  }
`;

const SelectedCategory = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  width: 10rem;
  height: 13.2rem;
  //margin-left: 1rem;
  position: relative;
  border-radius: 4px;

  :hover {
    background: rgba(64, 126, 219, 0.1);
  }

  :active {
    background: rgba(64, 126, 219, 0.3);
  }
`;

const CategorySelectedCover = styled.div`
  border-radius: 6px;
  width: 10rem;
  height: 13.2rem;
  background-color: rgba(64, 126, 219, 0.45);
  animation: fadein 0.7s;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 0;
  left: 0;

  .clicked-card-check {
    width: 50px;
    height: 4rem;
    background-image: url(${SsqImages.common.icon.checkedCard()});
    background-position: center;
    background-repeat: no-repeat;
  }
`;

